import { GiReceiveMoney, GiTakeMyMoney } from "react-icons/gi"
import { GrOverview } from "react-icons/gr"
import { MdOutlineDocumentScanner } from "react-icons/md"
import { RiInputField } from "react-icons/ri"
import { Privileges } from "../../../../util/PrivilegeConstants"
import FormOverview from "./FormOverview"
import FormFields from "./FormFields"
import ParticipantFee from "./ParticipantFee"
import Waivers from "./Waivers"
import FormPayments from "./FormPayments"
import styles from '../../../../styles/modules/RegistrationSetup.module.css';
import { GoChecklist } from "react-icons/go";
import { TbForms } from "react-icons/tb";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { RiSecurePaymentLine } from "react-icons/ri";
import { IoShieldCheckmarkOutline } from "react-icons/io5";

export const listOfOptions = ["Form Overview", "Form Field", "Participant Fee", "Waiver", "Payments"]

export const getComponentByIndex = (index, formTemplateId, privileges, formtemplateStatus, setIsUpdate) => {
    switch (index) {
        case 0:
            return (
                <>
                    {privileges?.MANAGE_FORM_OVERVIEW?.includes(Privileges.VIEW) ?
                        <FormOverview setIsUpdate={setIsUpdate} formTemplateId={formTemplateId} privileges={privileges} formtemplateStatus={formtemplateStatus} />
                        :
                        <div className={styles['form_overview_access_denied_page']}>
                            <p>You do not have the necessary privileges to access this feature. If you believe this is incorrect, please reach out to your system administrator for assistance.</p>
                        </div>}
                </>
            )
        case 1:
            return (
                <>
                    {privileges?.MANAGE_FORM_FIELD?.includes(Privileges.VIEW) ?
                        <FormFields formtemplateStatus={formtemplateStatus} formTemplateId={formTemplateId} privileges={privileges} />
                        :
                        <div className={styles['form_overview_access_denied_page']}>
                            <p>You do not have the necessary privileges to access this feature. If you believe this is incorrect, please reach out to your system administrator for assistance.</p>
                        </div>}
                </>
            )
        case 2:
            return (
                <>
                    {privileges?.MANAGE_PARTICIPANT_FEE?.includes(Privileges.VIEW) ?
                        <ParticipantFee formtemplateStatus={formtemplateStatus} formTemplateId={formTemplateId} privileges={privileges} />
                        :
                        <div className={styles['form_overview_access_denied_page']}>
                            <p>You do not have the necessary privileges to access this feature. If you believe this is incorrect, please reach out to your system administrator for assistance.</p>
                        </div>}
                </>
            )
        case 3:
            return (
                <>
                    {privileges?.MANAGE_WAIVER?.includes(Privileges.VIEW) ?
                        <Waivers formtemplateStatus={formtemplateStatus} formTemplateId={formTemplateId} privileges={privileges} />
                        :
                        <div className={styles['form_overview_access_denied_page']}>
                            <p>You do not have the necessary privileges to access this feature. If you believe this is incorrect, please reach out to your system administrator for assistance.</p>
                        </div>}
                </>
            )
        case 4:
            return(
                <>
                    {privileges?.MANAGE_PAYMENT?.includes(Privileges.VIEW) ?
                        <FormPayments formtemplateStatus={formtemplateStatus} formTemplateId={formTemplateId} privileges={privileges} />
                        :
                        <div className={styles['form_overview_access_denied_page']}>
                            <p>You do not have the necessary privileges to access this feature. If you believe this is incorrect, please reach out to your system administrator for assistance.</p>
                        </div>}
                </>
            )
    }
}
export const getIconByIndex = (index, activeTab) => {
    switch (index) {
        case 0:
            return (
                <GoChecklist className={activeTab === index ? `${styles['form_setting_tab_icon']} ${styles['active']}` : styles['form_setting_tab_icon']} />
            );
        case 1:
            return (
                <TbForms className={activeTab === index ? `${styles['form_setting_tab_icon']} ${styles['active']}` : styles['form_setting_tab_icon']} />
            );
        case 2:
            return (
                <RiMoneyDollarCircleLine className={activeTab === index ? `${styles['form_setting_tab_icon']} ${styles['active']}` : styles['form_setting_tab_icon']} />
            );
        case 3:
            return (
                <IoShieldCheckmarkOutline className={activeTab === index ? `${styles['form_setting_tab_icon']} ${styles['active']}` : styles['form_setting_tab_icon']} />
            )
        case 4:
            return (
                <RiSecurePaymentLine className={activeTab === index ? `${styles['form_setting_tab_icon']} ${styles['active']}` : styles['form_setting_tab_icon']} />
            )
    }
}